<template>
  <div class="risk_">
    <div class="title_">
      费率调整系数
      <div class="cutoff_"></div>
    </div>
    <!-- 通用类型start -->
    <div v-for="(item, index) in list" :key="index">
      <div class="flex_">
        <div class="flex_">
          <label>类型名称:</label>
          <a-input
            class="wid_150"
            v-model="item.itemName"
            placeholder="类型名称"
          />
          <a-icon class="icon_" type="plus" @click="addData(item, index)" />
        </div>
      </div>
      <div class="flex_">
        <label class="wid_160 gray_">名称</label>
        <label class="wid_160 gray_">系数</label>
        <label class="wid_160 gray_">子项代码</label>
      </div>
      <div
        class="flex_"
        v-for="(ele, idx) in item.premiumRules"
        :key="'i' + idx"
      >
        <a-input class="wid_160" placeholder="名称" v-model="ele.optinonName" />
        <a-input
          class="wid_150"
          placeholder="费率"
          v-model="ele.singlePremium"
        />
        <a-input
          class="wid_150"
          placeholder="子项代码"
          v-model="ele.optinonValue"
        />
        <a-icon
          class="icon_"
          type="minus"
          @click="deleteData(item, index, ele, idx)"
        />
      </div>
    </div>
    <!-- 通用类型end -->

    <!-- 特殊类型：地区调整系数start -->
    <div>
      <div class="flex_">
        <label>地区调整系数:</label>
        <a-input
          class="wid_150"
          v-model="areaObj.itemName"
          placeholder="类型名称"
        />
        <a-icon class="icon_" type="plus" @click="addAreaData()" />
      </div>
      <div class="flex_">
        <label class="wid_160 gray_">地区</label>
        <label class="wid_160 gray_">系数</label>
      </div>
      <div
        class="flex_"
        v-for="(ele, idx) in areaObj.premiumRules"
        :key="'i' + idx"
      >
        <a-select
          placeholder="地区"
          @change="(val) => handleAreaChange(val, idx)"
          :default-value="ele.optinonValue"
          class="wid_160"
        >
          <a-select-option
            v-for="(area, i) in ele.province"
            :key="i + 'a'"
            :value="area.provinceCode"
            >{{ area.provinceName }}</a-select-option
          >
        </a-select>
        <a-input
          class="wid_150"
          placeholder="费率"
          v-model="ele.singlePremium"
        />
        <a-icon class="icon_" type="minus" @click="deleteAreaData(idx)" />
      </div>
    </div>
    <!-- 特殊类型：地区调整系数end -->

    <!-- 特殊类型：工期调整系数start -->
    <div>
      <div class="flex_">
        <label>工期调整系数:</label>
        <a-input
          class="wid_150"
          v-model="dateObj.itemName"
          placeholder="类型名称"
        />
        <a-icon class="icon_" type="plus" @click="addDateData()" />
      </div>
      <div class="flex_">
        <label class="wid_160 wid_250 gray_">最小值</label>
        <label class="wid_160 wid_250 gray_">最大值</label>
        <label class="wid_160 wid_250 gray_">系数</label>
      </div>
      <div
        class="flex_"
        v-for="(ele, idx) in dateObj.premiumRules"
        :key="'i' + idx"
      >
        <a-input placeholder="最小值" class="wid_150" v-model="ele.dayMin">
          <a-select
            v-model="ele.dayMinUnit"
            slot="addonAfter"
            style="width: 70px"
          >
            <a-select-option value="y">年</a-select-option>
            <a-select-option value="m">月</a-select-option>
            <a-select-option value="d">日</a-select-option>
          </a-select>
        </a-input>
        <a-select
          v-model="ele.dayMinIsContain"
          slot="addonAfter"
          style="width: 80px"
        >
          <a-select-option value="0">不含</a-select-option>
          <a-select-option value="1">含</a-select-option>
        </a-select>
        ——
        <a-input placeholder="最大值" class="wid_150" v-model="ele.dayMax">
          <a-select
            v-model="ele.dayMaxUnit"
            slot="addonAfter"
            style="width: 70px"
          >
            <a-select-option value="y">年</a-select-option>
            <a-select-option value="m">月</a-select-option>
            <a-select-option value="d">日</a-select-option>
          </a-select>
        </a-input>
        <a-select
          v-model="ele.dayMaxIsContain"
          slot="addonAfter"
          style="width: 80px"
        >
          <a-select-option value="0">不含</a-select-option>
          <a-select-option value="1">含</a-select-option>
        </a-select>

        <a-input
          class="wid_150"
          placeholder="费率"
          v-model="ele.singlePremium"
        />
        <a-icon class="icon_" type="minus" @click="deleteDateData(idx)" />
      </div>
    </div>
    <!-- 特殊类型：工期调整系数end -->

    <!-- i云保暂不上线TODO:测试开放 -->
    <!-- 特殊类型：佣金调整系数start -->
    <div>
      <div class="flex_">
        <label>佣金调整系数:</label>
        <a-input
          class="wid_150"
          v-model="commission.itemName"
          placeholder="类型名称"
        />
        <a-icon class="icon_" type="plus" @click="addCommissionData()" />
      </div>
      <div class="flex_">
        <label class="wid_160 wid_250 gray_">最小值</label>
        <label class="wid_160 wid_250 gray_">最大值</label>
        <label class="wid_160 wid_250 gray_">系数</label>
      </div>
      <div
        class="flex_"
        v-for="(ele, idx) in commission.premiumRules"
        :key="'i' + idx"
      >
        <a-input placeholder="最小值" class="wid_150" v-model="ele.dayMin">
          <div slot="addonAfter">%</div>
        </a-input>
        <a-select
          v-model="ele.dayMinIsContain"
          slot="addonAfter"
          style="width: 80px"
        >
          <a-select-option value="0">不含</a-select-option>
          <a-select-option value="1">含</a-select-option>
        </a-select>
        ——
        <a-input placeholder="最大值" class="wid_150" v-model="ele.dayMax">
          <div slot="addonAfter">%</div>
        </a-input>
        <a-select
          v-model="ele.dayMaxIsContain"
          slot="addonAfter"
          style="width: 80px"
        >
          <a-select-option value="0">不含</a-select-option>
          <a-select-option value="1">含</a-select-option>
        </a-select>

        <a-input
          class="wid_150"
          placeholder="费率"
          v-model="ele.singlePremium"
        />
        <a-icon class="icon_" type="minus" @click="deleteCommissionData(idx)" />
      </div>
    </div>
    <!-- 特殊类型：佣金调整系数end -->

    <!-- i云保暂不上线TODO:测试开放 -->
    <!-- 特殊类型：最高投保份数start -->
    <div>
      <div class="flex_">
        <label>最高投保份数调整系数:</label>
        <a-input
          class="wid_150"
          v-model="countObj.itemName"
          placeholder="类型名称"
        />
      </div>
      <div class="flex_">
        <label class="wid_160 gray_">份数</label>
      </div>
      <div
        class="flex_"
        v-for="(ele, idx) in countObj.premiumRules"
        :key="'i' + idx"
      >
        <a-input
          class="wid_150"
          placeholder="份数"
          v-model="ele.singlePremium"
        />
      </div>
    </div>
    <!-- 特殊类型：最高投保份数end -->

    <!-- 特殊类型：免赔额调整系数start -->
    <div>
      <div class="flex_">
        <label>免赔额调整系数:</label>
        <a-input
          class="wid_150"
          v-model="deductible.itemName"
          placeholder="类型名称"
        />
        <a-icon class="icon_" type="plus" @click="addDeductible()" />
      </div>
      <div class="flex_">
        <label class="wid_160 gray_">险种代码</label>
        <label class="wid_160 gray_">免赔额度</label>
        <label class="wid_160 gray_">系数</label>
      </div>
      <div
        class="flex_"
        v-for="(ele, idx) in deductible.premiumRules"
        :key="'i' + idx"
      >
        <a-input class="wid_150" placeholder="险种代码" v-model="ele.optinonName"/>
        <a-input class="wid_150" placeholder="免赔额度" v-model="ele.optinonValue"/>
        <a-input class="wid_160" placeholder="系数" v-model="ele.singlePremium" />
        <a-icon
          class="icon_"
          type="minus"
          @click="deleteDeductible(idx)"
        />
      </div>
    </div>
    <!-- 特殊类型：免赔额调整系数end -->

    <a-button style="float: right; clear: both" @click="handleSave"
      >保存调整系数信息</a-button
    >
  </div>
</template>

<script>
import api from "@/utils/sdApi";
export default {
  props: {
    otherRiskInit: {
      type: Object,
      default: {
        list: [],
      },
    },
  },
  data() {
    return {
      list: this.otherRiskInit.list,
      areaObj: this.otherRiskInit.areaObj,
      dateObj: this.otherRiskInit.dateObj,
      //<!-- i云保暂不上线TODO:测试开放 -->
      commission: this.otherRiskInit.commission, //佣金调整系数
      countObj: this.otherRiskInit.countObj, //投保分数调整系数
      deductible: this.otherRiskInit.deductible, //免赔额调整系数
      province: [],
    };
  },
  mounted() {
    this.queryProvinces();
    if (this.$route.name == "edit") {
      this.handleSave();
    }
  },
  methods: {
    //地区
    addAreaData() {
      this.areaObj.premiumRules.push({
        optinonName: "",
        singlePremium: "",
        optinonValue: "",
        calculateMethod: 1,
        province: this.province,
      });
    },
    deleteAreaData(idx) {
      this.areaObj.premiumRules.splice(idx, 1);
    },
    handleAreaChange(val, idx) {
      console.log(val, "--->", this.areaObj.premiumRules);
      let isExit = this.province.find((item) => {
        return item.provinceCode == val;
      });
      if (isExit) {
        this.areaObj.premiumRules[idx].optinonName = isExit.provinceName;
        this.areaObj.premiumRules[idx].optinonValue = val;
      }
    },

    //工期和佣金类型公用方法,参数itemType-调整系数类型、objKey-操作的对象
    addType1CommonData(itemType, objKey) {
      let obj = {
        dayMin: "",
        dayMinIsContain: "0",
        dayMax: "",
        dayMaxIsContain: "0",
        singlePremium: "",
        calculateMethod: 1,
      };
      switch (itemType) {
        case "POLICY_DAYS":
          obj.dayMinUnit = "d";
          obj.dayMaxUnit = "d";
      }
      this[objKey].premiumRules.push(obj);
    },
    deleteType1CommonData(idx) {
      this[objKey].premiumRules.splice(idx, 1);
    },

    //工期
    addDateData() {
      this.dateObj.premiumRules.push({
        dayMin: "",
        dayMinUnit: "d",
        dayMinIsContain: "0",
        dayMax: "",
        dayMaxUnit: "d",
        dayMaxIsContain: "0",
        singlePremium: "",
        calculateMethod: 1,
      });
    },
    deleteDateData(idx) {
      this.dateObj.premiumRules.splice(idx, 1);
    },
    //工期 end

    //佣金调整
    addCommissionData() {
      this.commission.premiumRules.push({
        dayMin: "",
        dayMinUnit: "d",
        dayMinIsContain: "0",
        dayMax: "",
        dayMaxUnit: "d",
        dayMaxIsContain: "0",
        singlePremium: "",
        calculateMethod: 1,
      });
    },
    deleteCommissionData(idx) {
      this.commission.premiumRules.splice(idx, 1);
    },
    //佣金调整 end

    //免赔额
    addDeductible() {
      this.deductible.premiumRules.push({
            optinonName: "",
            optinonValue: "",
            calculateMethod: "1",
            singlePremium: "",
          });
    },
    deleteDeductible(idx) {
      this.deductible.premiumRules.splice(idx, 1);
    },
    //免赔额 end

    //通用类
    addData(item, index) {
      let list = [...this.list];
      list[index].premiumRules.push({
        itemName: "",
        singlePremium: "",
        optinonValue: "",
        calculateMethod: 1,
      });
      this.list = [...list];
    },
    deleteData(item, index, ele, idx) {
      let list = [...this.list];
      list[index].premiumRules.splice(idx, 1);
      this.list = [...list];
    },
    queryProvinces() {
      return api.queryProvinces().then((res) => {
        this.province = res.data;
      });
    },
    handleSave() {
      console.log(this.list, this.areaObj, this.dateObj);
      let result = this.formatList();
      this.$emit("change", result);
    },
    formatList() {
      let arr = [];
      //通用类型
      arr = [...this.list];
      //地区
      let obj = {
        itemName: this.areaObj.itemName,
        itemType: this.areaObj.itemType,
        premiumRules: [],
      };
      this.areaObj.premiumRules.map((item) => {
        obj.premiumRules.push({
          calculateMethod: item.calculateMethod,
          optinonName: item.optinonName,
          optinonValue: item.optinonValue,
          singlePremium: item.singlePremium,
        });
      });
      arr.push(obj);
      //工期
      arr.push(this.dateObj);

      //<!-- i云保暂不上线TODO:测试开放 -->
      // //佣金
      arr.push(this.commission);
      // //投保份数
      arr.push(this.countObj);
      // //免赔额
      arr.push(this.deductible);
      return arr;
    },

    dataFormat(arr, numUnit, keyArr) {
      //参数：numUnit-被除数,arr-数据列表,keyArr-要处理的key数组
      let array = [];
      arr.map((item) => {
        for (let i in keyArr) {
          item[keyArr[i]] = parseFloat(item[keyArr[i]]) / numUnit;
        }
        array.push(item);
      });
      return array;
    },
  },
};
</script>

<style lang="scss" scoped>
.risk_ {
  padding-bottom: 50px;
}
.title_ {
  margin: 30px 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: bold;
  .cutoff_ {
    // width:90%;
    flex: 1;
    height: 5px;
    background: #f0f0f0;
  }
}
.icon_ {
  cursor: pointer;
  &:hover {
    color: red;
  }
}
.wid_150 {
  width: 150px;
  margin: 10px;
}
.wid_160 {
  width: 170px;
  margin: 10px;
}
.wid_250 {
  width: 260px;
  margin: 10px;
}
.flex_ {
  display: flex;
  align-items: center;
  .gray_ {
    color: gray;
    margin: 2px 10px;
  }
  label {
    font-weight: bold;
  }
}
</style>